import MMatchCard from './MMatchCard.vue';

export { MMatchCard };
export default MMatchCard;
